<template>
  <div id="contact-us" class="mx-auto max-w-screen-xl">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
  </div>
</template>

<style>
#contact-us {
  .brand-window-text-overlay {
    @apply min-h-0 mb-0;
  }

  .form-cta {
    @apply mb-0;

    .form > header {
      @apply flex gap-4 justify-between flex-wrap;
    }
  }

  #marshall-fire-rebuilding {
    @apply py-7;
  }

  .text-cta {
    p {
      @apply leading-8;

      a {
        @apply text-sm text-bc-dark-blue underline;
      }
    }

    .buttons a {
      @apply uppercase;
    }
  }
}
</style>

<script setup>
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";

import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, {
  uri: "/contact-us/ask-a-question/",
});

const organisms = computed(() => {
  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;

breadcrumbsList.value = [];
</script>
